import { defineComponent } from 'vue';
import axios, { AxiosResponse } from 'axios';
import DCApp from "./../Shared/App.vue";
import * as Vue from 'vue';
import { createPinia } from 'pinia';

let glang: string;
glang = "fr";
let gnumpages: number;
gnumpages = 0;
let gpage: number;
gpage = 1;

export class dccore_dossierspages {
    //id dccore_dossiers
    public iddossier:number = 0;
    public  page: number = 0;
    public  titrepage: string = "";
    public  contenu: string = "";
    }

export class dccore_dossiers {
    public titre: string = "";
    public description: string = "";
    public proprietaire: number = 0;
    public auteur: string = "";
    public date!: Date;
    public ispublish: boolean = false;
    public lan: string = "";
    public idwp: number = 0;
    public idlogo: number = 0;
    public pages: dccore_dossierspages[] = [];
}

export class DossierElem {
    public  titre: string = "";
    public  description: string = "";
    public  auteur: string = "";
    public  id: number = 0;
    public  proprietaire: number = 0;
    public  date!: Date;
        public  url: string = "";
        public  logourl: string = "";
    }

export class AideViewApiModel {
    public ishome: boolean = false;
    public dossierstab: DossierElem[] = [];
    public dossier: dccore_dossiers | null = null;

    public dospage: dccore_dossierspages | null = null;
    public contenu: string = "";
    public numpages: number = 0;
    public m_urlsuivant: string = "";
    public m_urlprec: string = "";
    public urlfacebook: string = "";
    public urltwitter: string = "";
    public islargeimg: boolean = false;
}

const mixin = defineComponent({
    data() {
        return {
             dcloadingnews:false,
            last_page: 2,
            first_page:1,
             numpages: 0,
             currentlan:"fr",
            postdossiers: [] as dccore_dossiers[],
        };
    },
   

     created() {
         window.addEventListener('scroll', this.handleScroll, { passive: true });
    },

     unmounted() {
         window.removeEventListener('scroll', this.handleScroll);
    },

    mounted() {
        this.currentlan = glang;
        this.numpages = gnumpages;
        this.last_page = gpage + 1;
        this.first_page = gpage;
    },

    methods: {
        async GetListeDossiers(page: number): Promise<dccore_dossiers[]> {
            const url = `/api/v1.0/Aide/GetListeDossiers?page=${page}`;
            const response = await axios.get<dccore_dossiers[]>(url);
            return response.data;
        },

       async handleScroll(event: any) {
            let self = this;
           let offset = $('.mc_piedpagebottom').offset();
           console.log('handleScroll1', offset);
            if (offset == undefined)
               return;
           console.log('handleScroll2', offset);
            let height: number | undefined = $(window).height();
            let scrolltop: number | undefined = $(window).scrollTop();
            if (height === undefined || scrolltop === undefined)
               return;
           console.log('handleScroll3', height, scrolltop, this.last_page, this.numpages);
            if ((offset.top - height <= scrolltop) && this.last_page <= this.numpages && !this.dcloadingnews) {
                this.dcloadingnews = true;
                console.log('handleScroll4', height, scrolltop, this.last_page, this.numpages);
                const newdossiers = await this.GetListeDossiers(this.last_page);
                if (newdossiers != null) {
                    console.log('handleScroll5', newdossiers.length);
                    self.postdossiers = self.postdossiers.concat(newdossiers);
                   // history.pushState(null, "", self.urldossier.replace("888552", (self.last_page - 1).toString()));
                    self.last_page++;
                    self.dcloadingnews = false;
                }
            }
        }
    }

});


export class AideHomeComponent {
    public constructor() {
    }

    public Init(lang: string, page: number, numpages: number) {
        glang = lang;
        gnumpages = numpages;
        gpage = page;
        DCApp.mixins = [mixin];
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
        app.mount('#rootpage');
    }
}
(<any>(window)).AideHomeComponent = function () { return new AideHomeComponent(); };